<template>
  <div>
    <button class="d-block d-lg-none btn-toggle-mobile-facets" @click="toggleFilter(true)">
      <i class="icon-filter"></i>
      Filter resultaten
    </button>
    <div class="accommodation-facet-list" v-bind:class="{ 'mobile-view-active': isMobileViewActive }">
      <div class="d-flex d-lg-none justify-content-between align-items-center mb-3">
        <h4>Filter resultaten</h4>
        <i class="icon-close" @click="toggleFilter(false)"></i>
      </div>
      <button type="button" class="btn-clear-filters" @click="store.resetFacets()">
        Wis alle filters
      </button>
      <aside class="facet-filter-container">
        <facet
            v-for="(facetGroup, name, index) in facetGroups"
            :title="name"
            :default-open="!collapsedByDefault.includes(facetGroup[0]?.name)"
        >
          <template v-for="facet in facetGroup">
            <CheckBoxType v-if="facet.type === filterTypes.CHECKBOX" :name="facet.name" :label="facet.label" :value="facet.values[0].key" :tooltip="tooltipConfigs[facet.name] || null"></CheckBoxType>
            <CheckBoxesType v-if="facet.type === filterTypes.CHECKBOXES" :name="facet.name" :options="facet.values" :tooltip="tooltipConfigs[facet.name] || null"></CheckBoxesType>
            <SelectType v-if="facet.type === filterTypes.SELECT" :name="facet.name" :options="facet.values" :tooltip="tooltipConfigs[facet.name] || null"></SelectType>
            <NumberType v-if="facet.type === filterTypes.NUMBER" :name="facet.name" :label="facet.label" :tooltip="tooltipConfigs[facet.name] || null"></NumberType>
          </template>
        </facet>
      </aside>

      <button v-if="isMobileViewActive" @click="toggleFilter(false)" class="btn btn-secondary flex-scale btn-search">
          Bekijk resultaten
      </button>
    </div>
  </div>
</template>

<script>
import Facet from "./Facet";
import { store } from '../../../store.js'
import { filterTypes } from "../../../variables";
import { vueTranslator } from '../../../mixins.js';
import CheckBoxesType from "./FacetTypes/CheckBoxesType";
import CheckBoxType from "./FacetTypes/CheckBoxType";
import SelectType from "./FacetTypes/SelectType";
import NumberType from "./FacetTypes/NumberType";

export default {
  name: "FacetList",
  components: { Facet, CheckBoxType, CheckBoxesType, SelectType, NumberType },
  data() {
    return {
      store,
      filterTypes,
      isMobileViewActive: false,
      isSelfCook: false,
      isFullBoard: false,
      collapsedByDefault: [
      'member_of_i_v_v', 
      'bed_type', 
      'dagzalen', 
      'aantal_toiletten', 
      'toegankelijke_slaapplaatsen', 
      'oppervlakte_terrein', 
      'elektriciteit_op_het_terrein', 
      'terrein_toegankelijk_personenauto', 
      'dichtste_treinstation'],
    }
  },
  computed: {
    tooltipConfigs() {
      return {
        member_of_i_v_v: {
          text: vueTranslator('facet.ivv.tooltip_text'),
          linkUrl: vueTranslator('facet.ivv.tooltip_link_url'),
          linkText: vueTranslator('facet.ivv.tooltip_link_text'),
        },
        bookable_online: {
          text: vueTranslator('facet.bookable_online.tooltip_text'),
          linkUrl: vueTranslator('facet.bookable_online.tooltip_link_url'),
          linkText: vueTranslator('facet.ivv.tooltip_link_text'),
        },
        meal_type: {
          meal_type_self_cooking: {
            text: vueTranslator('facet.self_cooking.tooltip_text'),
          },
          meal_type_full_board: {
            text: vueTranslator('facet.full_board.tooltip_text'),
          },
        },
        bed_type: {
          text: vueTranslator('facet.bed_type.tooltip_text'),
        },
        toegankelijkheidslabel: {
          linkUrl: vueTranslator('facet.toegankelijkheidslabel.tooltip_link_url'),
          linkText: vueTranslator('facet.toegankelijkheidslabel.tooltip_link_text'),
          linkText: vueTranslator('facet.ivv.tooltip_link_text'),
        },
        hudo_graven_toegestaan: {
          text: vueTranslator('facet.hudo.tooltip_text'),
        },
      };
    },
    facetGroups() {
      return this.store.facets.reduce(
          (facetGroups, facet) => ({
            ...facetGroups,
            [facet['group']]: [
              ...(facetGroups[facet['group']] || []),
              facet,
            ],
          }),
          {},
      );
    }
  },
  methods: {
    toggleFilter(state) {
      this.isMobileViewActive = state;
      document.querySelector('body').classList.toggle('no-scrolling')
    }
  }
}
</script>

<style scoped>

</style>
